module.exports = __webpack_public_path__ + "static/media/nutri.a31efedb.png";